<!--图片上传-->
<template>
  <div>
    <el-upload style="display:flex;align-items: center;
"
               :action="api.uploadFileUrl"
               :on-remove="handleRemove"
               accept=".jpeg,.png,.jpg,.bmp,.gif"
               :before-upload="checkFileType"
               list-type="picture-card"
               :file-list="photoList"
               :on-success="(res,file, fileList) => {handleSuccess(res,file, fileList)}"
               :on-change="(files, fileList) => {handleImageChange(fileList)}"
               :auto-upload="true"
               :headers="headers"
               :on-preview="handlePictureCardPreview"
    >
      <i slot="default" class="el-icon-plus"></i>
    </el-upload>


    <el-image-viewer
      style="z-index: 9999;"
      v-if="dialogVisible"
      :on-close="closeImgViewer"
      :url-list="dialogImageUrlList"/>
  </div>
</template>

<script>
import api from "@/api/projectApi";
import store from "@/store";

export default {
  name: 'photoUpload',
  props: {
    photoUrl: {
      type: [Array],
      require: true
    }
  },

  computed: {
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },

  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },

  data() {
    return {
      photoList: [],
      dialogImageUrlList: [],
      dialogVisible: false,
    }
  },

  watch: {
    photoUrl: {
      handler(url) {
        if (url) {
          let list = []
          if (url !== null && url !== '' && url !== undefined) {
            this.photoList = url
          }
        } else {
        }
      },
      deep: true,
      immediate: false,
    },
    photoList: {
      handler(n) {
        if (n.length > 0) {
          this.$emit('update:photoUrl', this.photoList)
        } else {
          this.$emit('update:photoUrl', null)
        }
      },
      deep: true,
      immediate: false,
    },

  },


  methods: {
    checkFileType (file) {
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.'))
      // jpeg,.png,.jpg,.bmp,.gif
      if (
        fileType === '.jpg' ||
        fileType === '.png' ||
        fileType === '.jpeg' ||
        fileType === '.bmp' ||
        fileType === '.gif'
      ) {
        // 不处理
      } else {
        this.$message.error(
          '不是,jpeg,.png,.jpg,.bmp,.gif文件,请上传正确的图片类型'
        )
        return false
      }
    },

    // handleRemove() {
    //
    //   this.photoList = []
    //   this.$emit('removePic', null)
    //   console.log("删除了照片",this.photoList);
    //
    // },

    handleRemove(file, fileList) {
      // 找到当前点击的照片索引
      const index = fileList.findIndex(item => item.uid === file.uid);
      if (index !== -1) {
        fileList.splice(index, 1); // 从fileList中移除当前照片
      }
      this.$emit('removePic', fileList); // 触发传递给父组件的事件，将更新后的fileList传递出去
    },

    handleSuccess(res, file, fileList) {
      let url = res.data.url
      console.log(url, "photoUrl")
      // let list = []
      if (url !== null && url !== '' && url !== undefined) {
        this.photoList.push({url: url})
      }
      // this.photoList = list
      console.log(this.photoList,"this.photoList的值");
    },

    handleImageChange(fileList) {
      // this.photoList = fileList
    },


    handlePictureCardPreview(file) {
      this.dialogImageUrlList = [file.url]
      this.dialogVisible = true
    },


    closeImgViewer() {
      this.dialogVisible = false
    },
  },
};
</script>

<style scoped lang="scss">
// 图片大小
::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 60px!important;;
  height: 60px!important;;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}
// 边框大小
::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 60px;
  height: 60px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}
// 上传按钮
::v-deep  .el-upload--picture-card {
  margin-top: 0px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}
</style>
